var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{class:'text-' + _vm.color,on:{"click":function($event){return _vm.go()}}},[_c('i',{staticClass:"fas fa-chevron-left mr-1",staticStyle:{"font-size":"1.4em"}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }